module.exports = __webpack_public_path__ + "static/media/check.0709e909.png";